import React from "react";
import {Box, Collapse, IconButton} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {Close} from '@material-ui/icons';

export function ErrorBar(props){
    const {error,onClear} = props;

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={!!error}>
                <Alert severity='error' variant='filled'
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                if(onClear){
                                    onClear();
                                }
                            }}
                        >
                            <Close fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                    {(error || '').substring(0,100)}
                </Alert>

            </Collapse>
        </Box>
    );
}

export function MessageBar(props){
    const {message,onClear} = props;

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={!!message}>
                <Alert severity='info'
                       action={
                           <IconButton
                               aria-label="close"
                               color="inherit"
                               size="small"
                               onClick={() => {
                                   if(onClear){
                                       onClear();
                                   }
                               }}
                           >
                               <Close fontSize="inherit" />
                           </IconButton>
                       }
                       sx={{ mb: 2 }}
                >
                    {(message || '').substring(0,100)}
                </Alert>

            </Collapse>
        </Box>
    );
}